<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Company Vital Signs</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col md="4">
          <units-progress :data="unitsData" :closedUnits="closedUnits" v-if="unitsData && closedUnits"></units-progress>
        </b-col>
        <b-col md="4">
          <volume-progress :data="volumeData" :closedSalesVolume="closedSalesVolume" v-if="unitsData && closedSalesVolume"></volume-progress>
        </b-col>
        <b-col md="4">
          <gci-progress :data="gciData" :companyGci="companyGci" v-if="unitsData && companyGci"></gci-progress>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8">
          <monthly-gci :monthlyProfits="monthlyProfits" :profitGoals="profitGoals"></monthly-gci>
        </b-col>
        <pipeline-ratings :ratings="ratings" v-if="ratings"></pipeline-ratings>
      </b-row>
      <b-row>
        <b-col>
          <observed-upgrade-overlay :title="'Goal Gap'" :upgradeImg="'overlays/goal-gap.png'" :placeholderImg="'placeholders/goal-gap.png'" v-if="!subscribed && !user.kwyp"></observed-upgrade-overlay>
          <goal-gap v-else></goal-gap>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import GoalGap from './GoalGap';
import PipelineRatings from './PipelineRatings';
import errorsMixin from '@/mixins/errors-mixin';
import UnitsProgress from './Progress/UnitsProgress';
import GciProgress from './Progress/GciProgress';
import VolumeProgress from './Progress/VolumeProgress';
import economicModelMixin from '@/mixins/economicModel-mixin';
import ObservedUpgradeOverlay from '@/views/Components/Overlays/ObservedUpgradeOverlay';
import MonthlyGci from '@/views/Components/Charts/MonthlyGci';

export default {
  mixins: [economicModelMixin, errorsMixin],
  components: {
    RouteBreadCrumb,
    GoalGap,
    PipelineRatings,
    UnitsProgress,
    GciProgress,
    VolumeProgress,
    ObservedUpgradeOverlay,
    MonthlyGci
  },
  data() {
    return {
      init: false,
      year: new Date().getFullYear(),
      unitsData: null,
      gciData: null,
      volumeData: null,
      profits: null,
      ratings: null,
      monthlyProfits: [],
      profitGoals: [],
    };
  },
  computed: {
    ...mapGetters({
      user: 'observed/observed',
      subBasic: 'observed/subBasic',
      subStandard: 'observed/subStandard',
      subPremium: 'observed/subPremium'
    }),
    userRoute() {
      return process.env.VUE_APP_API_BASE_URL + '/users/' + this.$route.params.user;
    },
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    }
  },
  methods: {
    async getStats() {
      axios.get(this.userRoute + "/portal?year=" + this.year)
      .then(response => {
        this.profits = response.data.profits;
        this.ratings = response.data.ratings;
        this.unitsData = response.data.units;
        this.gciData = response.data.gci;
        this.volumeData = response.data.volume;
        this.monthlyProfits = response.data.monthly_profits;
        this.profitGoals = response.data.profit_goals;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getEconomicModel() {
      axios.get(this.userRoute + "/economic-model?year=" + this.year)
      .then(response => {
        this.economicModel = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getCos() {
      axios.get(this.userRoute + "/cost-of-sale?year=" + this.year)
      .then(response => {
        this.cos = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  created() {
    this.getEconomicModel();
    this.getCos();
    this.getStats();
  },
  mounted() {
    document.title = "Observatory Dashboard";
  }
};
</script>
